import type {Auction} from '@/entities/Experiences/type/experiences';

export const isAuctionStarted = (auction?: Auction): boolean => {
  return auction ? new Date(auction.start_date_time) <= new Date() : false;
};
